/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Intro_Stat_IntegrationsInputs */

const es_home_intro_stat_integrations = /** @type {(inputs: Home_Intro_Stat_IntegrationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`integraciones disponibles`)
};

const en_home_intro_stat_integrations = /** @type {(inputs: Home_Intro_Stat_IntegrationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`available integrations`)
};

/**
* | output |
* | --- |
* | "available integrations" |
*
* @param {Home_Intro_Stat_IntegrationsInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const home_intro_stat_integrations = /** @type {((inputs?: Home_Intro_Stat_IntegrationsInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Intro_Stat_IntegrationsInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_home_intro_stat_integrations(inputs)
	return en_home_intro_stat_integrations(inputs)
});
export { home_intro_stat_integrations as "home.intro.stat_integrations" }